import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=d1bb44ae&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=d1bb44ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bb44ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1bb44ae')) {
      api.createRecord('d1bb44ae', component.options)
    } else {
      api.reload('d1bb44ae', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=d1bb44ae&scoped=true&", function () {
      api.rerender('d1bb44ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QDeX9E4o6ykp/JS/teamMember.vue"
export default component.exports